import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  useScrollTrigger,
  Slide
} from '@mui/material';
import { ReactComponent as LogoTagline } from '../../assets/logo.svg';
import CTAButton from './CTAButton';

// Hide AppBar on scroll
function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const Navigation = ({ onSectionClick, onGetStartedClick }) => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (onSectionClick) {
      onSectionClick(sectionId);
    }
  };

  const handleGetStartedClick = () => {
    scrollToSection('pricing-section');
    if (onGetStartedClick) {
      onGetStartedClick();
    }
  };

  return (
    <>
      <HideOnScroll>
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%)',
            backdropFilter: 'blur(20px)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.03)'
          }}
        >
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              py: { xs: 0.5, md: 1 },
              px: { xs: 2, md: 3 },
              minHeight: { xs: '56px', md: '64px' }
            }}
          >
            {/* Left Third: Logo */}
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
              <LogoTagline style={{
                width: 'auto',
                height: '36px',
                maxWidth: '220px'
              }} />
            </Box>

            {/* Navigation Links (Center Group) - Hide on small screens */}
            <Box sx={{ flex: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center', gap: 2.5 }}>
              <Button
                color="inherit"
                onClick={() => scrollToSection('features')}
                sx={{ 
                  color: 'text.secondary', 
                  fontWeight: 500, 
                  ':hover': { 
                    color: 'primary.main', 
                    backgroundColor: 'transparent' 
                  } 
                }}
              >
                Features
              </Button>
              <Button
                color="inherit"
                onClick={() => window.location.href = '/demo'}
                sx={{ 
                  color: 'text.secondary', 
                  fontWeight: 500, 
                  ':hover': { 
                    color: 'primary.main', 
                    backgroundColor: 'transparent' 
                  } 
                }}
              >
                Demo
              </Button>
              <Button
                color="inherit"
                onClick={() => scrollToSection('testimonials-section')}
                sx={{ 
                  color: 'text.secondary', 
                  fontWeight: 500, 
                  ':hover': { 
                    color: 'primary.main', 
                    backgroundColor: 'transparent' 
                  } 
                }}
              >
                Testimonials
              </Button>
              <Button
                color="inherit"
                onClick={() => scrollToSection('pricing-section')}
                sx={{ 
                  color: 'text.secondary', 
                  fontWeight: 500, 
                  ':hover': { 
                    color: 'primary.main', 
                    backgroundColor: 'transparent' 
                  } 
                }}
              >
                Pricing
              </Button>
              <Button
                color="inherit"
                onClick={() => scrollToSection('faq-section')}
                sx={{ 
                  color: 'text.secondary', 
                  fontWeight: 500, 
                  ':hover': { 
                    color: 'primary.main', 
                    backgroundColor: 'transparent' 
                  } 
                }}
              >
                FAQ
              </Button>
            </Box>

            {/* Right Third: Buttons */}
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gap: { xs: 1, md: 2 } }}>
                <Button
                  color="primary"
                  sx={{
                    mr: { xs: 1, md: 2 },
                    px: { xs: 2, md: 3 },
                    py: { xs: 0.5, md: 1 },
                    fontSize: { xs: '0.875rem', md: '0.95rem' },
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    color: 'text.secondary',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      color: 'primary.main'
                    }
                  }}
                  onClick={() => window.location.href = '/login'}
                >
                  Log in
                </Button>
                <CTAButton
                  variant="navbar"
                  onClick={handleGetStartedClick}
                  sx={{
                    display: { xs: 'none', md: 'inline-flex' }
                  }}
                >
                  Get Started
                </CTAButton>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar /> {/* Spacer for fixed AppBar */}
    </>
  );
};

export default Navigation; 